<template>
  <BlBackdrop :footer="false">
    <div class="flex flex-col gap-4 py-8" :style="{ width: '64rem' }">
      <div class="px-8 flex items-center justify-between">
        <BlTextTitle4 text="Invite new bulk members" />
        <BlInputButton
          type="outlined"
          icon="plus"
          label="New member"
          @clicked="onNewMember"
        />
      </div>
      <div
        class="px-8 flex flex-col overflow-y-auto"
        :style="{ height: 'calc(100vh - 24rem)' }"
      >
        <div
          v-for="(user, idx) in usersInput"
          :key="user.id"
          class="py-3 flex items-center gap-2 border-b border-slate-400"
        >
          <BlInputText
            :input="{ placeholder: 'Name', model: user.nameInput }"
            @changed="onInputName(idx, $event)"
          />
          <BlTooltip
            :tooltip="
              user.emailError
                ? `<div class='w-60'>${user.emailError}</div>`
                : ``
            "
            class="w-full"
          >
            <BlInputText
              :input="{
                placeholder: 'Email',
                inputType: 'email',
                model: user.emailInput,
                error: user.emailError ? 'true' : '',
                suffix: user.emailError
                  ? `
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path fill-rule='evenodd' clip-rule='evenodd' d='M9.401 3.00305C10.556 1.00305 13.444 1.00305 14.598 3.00305L21.953 15.7511C23.107 17.7511 21.663 20.2511 19.354 20.2511H4.645C2.336 20.2511 0.892995 17.7511 2.047 15.7511L9.4 3.00305H9.401ZM12 8.25005C12.1989 8.25005 12.3897 8.32907 12.5303 8.46972C12.671 8.61037 12.75 8.80114 12.75 9.00005V12.7501C12.75 12.949 12.671 13.1397 12.5303 13.2804C12.3897 13.421 12.1989 13.5001 12 13.5001C11.8011 13.5001 11.6103 13.421 11.4697 13.2804C11.329 13.1397 11.25 12.949 11.25 12.7501V9.00005C11.25 8.80114 11.329 8.61037 11.4697 8.46972C11.6103 8.32907 11.8011 8.25005 12 8.25005ZM12 16.5001C12.1989 16.5001 12.3897 16.421 12.5303 16.2804C12.671 16.1397 12.75 15.949 12.75 15.7501C12.75 15.5511 12.671 15.3604 12.5303 15.2197C12.3897 15.0791 12.1989 15.0001 12 15.0001C11.8011 15.0001 11.6103 15.0791 11.4697 15.2197C11.329 15.3604 11.25 15.5511 11.25 15.7501C11.25 15.949 11.329 16.1397 11.4697 16.2804C11.6103 16.421 11.8011 16.5001 12 16.5001Z' fill='#DD3F30'/>
                    </svg>
                  `
                  : ``
              }"
              @changed="onInputEmail(idx, $event)"
            />
          </BlTooltip>
          <BlSelectBox
            class="max-w-72"
            v-model="usersInput[idx].roleInput"
            placeholder="Select role"
            :options="roleOptions"
            @change="usersInput[idx].roleInput = $event"
          />
          <BlInputButton
            type="outlined-error"
            icon="delete"
            dense
            :disabled="usersInput.length < 2"
            @clicked="onRemoveMember(user.id)"
          />
        </div>
      </div>
      <div class="px-8 flex items-center justify-between">
        <div class="flex flex-col">
          <BlTextTitle4 :text="usersInput.length" class="text-light-purple" />
          <BlTextBody2 text="New member(s) invited" />
        </div>
        <div class="flex items-center gap-4">
          <BlInputButton
            type="plain"
            label="Cancel"
            @clicked="$emit('close-modal')"
          />
          <BlInputButton
            label="Generate invitation link"
            :loading="submitLoading"
            :disabled="isDisabledSubmit"
            @clicked="onSubmit"
          />
        </div>
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash/debounce";

import BlBackdrop from "../../../BlBackdrop.vue";
import BlTextTitle4 from "../../../BlTextTitle4.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";
import BlTooltip from "../../../BlTooltip.vue";
import BlInputButton from "../../../BlInputButton.vue";
import BlInputText from "../../../BlInputText.vue";
import BlSelectBox from "../../../BlSelectBox.vue";

export default {
  name: "InviteManualBulkUserModal",
  components: {
    BlBackdrop,
    BlTextTitle4,
    BlTextBody2,
    BlTooltip,
    BlInputButton,
    BlInputText,
    BlSelectBox
  },
  props: {
    centerId: { type: Number, required: true }
    // @close-modal
  },
  data() {
    return {
      submitLoading: false,
      userRoles: {
        admin: "Admin",
        staff: "Therapist",
        super_admin: "Super admin"
      },
      usersInput: [
        {
          id: "new-user",
          nameInput: "",
          emailInput: "",
          emailError: "",
          roleInput: "staff"
        }
      ],
      roleOptions: [
        { value: "admin", label: "Admin" },
        { value: "staff", label: "Therapist" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isDisabledSubmit() {
      const foundEmpty = this.usersInput.find(
        i => !i.nameInput || !i.emailInput
      );
      if (foundEmpty) return true;

      const foundError = this.usersInput.find(i => i.emailError);
      if (foundError) return true;

      return false;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["checkUserEmail", "inviteManualBulkUser", "showToast"]),
    onInputName(idx, payload) {
      const name = payload.value;
      this.usersInput[idx].nameInput = name;
    },
    onInputEmail(idx, payload) {
      const email = payload.value;
      if (!email) return;

      const index = this.usersInput.findIndex(i => i.emailInput === email);
      this.usersInput[idx].emailInput = email;
      if (index > -1) {
        const message =
          "This email is already associated with another member. Please use a different email address.";
        this.usersInput[idx].emailError = message;
        // this.usersInput[index].emailError = message;
        return;
      }
      this.onCheckEmail(idx, email);
    },
    onCheckEmail: debounce(async function(idx, email) {
      const params = { email };
      const { available } = await this.checkUserEmail(params);
      if (!available) {
        this.usersInput[idx].emailError =
          "This email is already associated with another member. Please use a different email address.";
        return;
      }
      this.usersInput[idx].emailError = "";
    }, 1000),
    onNewMember() {
      function getRandomId() {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let combination = "";
        for (let i = 0; i < 6; i++) {
          combination += chars[Math.round(Math.random() * 35)];
        }
        return `new-user-${combination}`;
      }
      const member = {
        id: getRandomId(),
        nameInput: "",
        emailInput: "",
        emailError: "",
        roleInput: "staff"
      };
      this.usersInput.push(member);
    },
    onRemoveMember(id) {
      this.usersInput = this.usersInput.filter(i => i.id !== id);
    },
    async onSubmit() {
      const params = {
        center_id: this.centerId,
        users: this.usersInput.map(i => ({
          name: i.nameInput,
          email: i.emailInput,
          role: i.roleInput
        }))
      };

      this.submitLoading = true;
      const { success, response } = await this.inviteManualBulkUser(params);
      this.submitLoading = false;
      if (!success) return;
      const title = "Downloading invited new member details";
      this.showToast({ title, message: "", type: "success" });

      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");

      let filename = "";
      const disposition = response.headers["content-disposition"];
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }

      link.href = href;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);

      this.$emit("after-commit");
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/center/centerTeam/InviteManualBulkUserModal.vue